export default __webpack_public_path__ + "static/media/image.maadya-digital.424cf3da.png";